let PANDAPAY_PUBLIC_KEY = null;

function setPublicKey(publicKey) {
    PANDAPAY_PUBLIC_KEY = publicKey;
}

/* eslint-disable */
function initPandaPay(scriptLoadedCallback, errorCallback) {
  const pandaJsUrl = 'https://d2t45z63lq9zlh.cloudfront.net/panda-v0.0.5.min.js'

  const scriptTags = document.getElementsByTagName('script')[0]
  const scriptElement = document.createElement('script')

  scriptElement.src = pandaJsUrl
  scriptElement.onload = () => {
    /* global Chart require */
    /* eslint global-require: 0 */
    scriptLoadedCallback(PANDAPAY_PUBLIC_KEY, window.Panda)
  }
  if (errorCallback) {
    scriptElement.onerror = () => errorCallback()
  }

  scriptTags.parentNode.insertBefore(scriptElement, scriptTags)
}

export default {
  setPublicKey,
  initPandaPay,
}
